// extracted by mini-css-extract-plugin
module.exports = {"content":"FabTitle_content__2QWHe","img":"FabTitle_img__3ACqv","separator":"FabTitle_separator__2kYiw","title":"FabTitle_title__2i3AB"};